import React from 'react';
import Script from 'next/script';

const FriendbuyAuthScript = () => (
  <>
  <Script type='text/javascript' src='/api/friend-buy-auth' strategy='beforeInteractive' />
  <Script id='friendbuyAuthScript' strategy='afterInteractive'
  dangerouslySetInnerHTML={{
    __html: `
      window["friendbuyAPI"] = friendbuyAPI = window["friendbuyAPI"] || [];

      friendbuyAPI.push([
        "auth",
        window.friendbuyAuth.authString,
        window.friendbuyAuth.signature
      ]);
    `}}
  />
  <Script id='friendbuy' strategy='afterInteractive'
  dangerouslySetInnerHTML={{
    __html: `
      window["friendbuyAPI"] = friendbuyAPI = window["friendbuyAPI"] || [];

      // registers your merchant using your merchant ID found in the
      // retailer app https://retailer.fbot.me/settings/general
      friendbuyAPI.merchantId = "d70b976f-f875-440d-8a31-e6f892b5ab02";
      friendbuyAPI.push(["merchant", friendbuyAPI.merchantId]);

      // load the merchant SDK and your campaigns
      (function (f, r, n, d, b, u, y) {
        while ((u = n.shift())) {
          (b = f.createElement(r)), (y = f.getElementsByTagName(r)[0]);
          b.async = 1;
          b.src = u;
          b.onload = function() {
            document.dispatchEvent(new Event("friendbuy-script-loaded"));
          }
          y.parentNode.insertBefore(b, y);
        }
      })(document, "script", [
        "https://static.fbot.me/friendbuy.js",
        "https://campaign.fbot.me/" + friendbuyAPI.merchantId + "/campaigns.js",
      ]);`,}}
  />
  </>
);

FriendbuyAuthScript.propTypes = {
};

FriendbuyAuthScript.defaultProps = {
};


export default FriendbuyAuthScript;
